import React from "react";
import "./promo.scss";
import penawaran from "../../../Media/hardsell_com.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMedal} from "@fortawesome/free-solid-svg-icons";

const Penawaran = () => {
  const Cherrywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282172727291&text=Halo%20Swandy,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Komersial%20BSD%20Gading%20Serpong%20(Promo)%20https://komersialbsdgadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  const poin = [
    "Free DP",
    "Cashback Up to 270 Juta",
    "Free AC",
    "Free CCTV",
    "Free IPKL",
    "Strategic Location",
    "10k Daily Vehicle Traffic",
    "78k Surrounding Market",
    "Easy Access",
    "Strategic Location",
    "Surrounded by Many Residential",
    "More Than 200.000 Residents",
  ];
  return (
    <div id="promo" className="promosumbog">
      <div className="promo-sumbog">
        <div className="gambarpromo">
          <img src={penawaran} alt={penawaran} />
        </div>
        <div className="ket-promo">
          <div className="judul">
            <h1>Promo Ruko Komersial BSD & Gading Serpong</h1>
          </div>
          <div className="promolist">
            <div className="pointpenawaran">
              {poin.map((image, index) => (
                <div className="penawaranpoin" index={index}>
                  <FontAwesomeIcon icon={faMedal} />
                  <span style={{color: "white"}}>&nbsp;&nbsp;{image}</span>
                </div>
              ))}
            </div>
          </div>
          <button className="buttonpenawaran" onClick={Cherrywa}>
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
};

export default Penawaran;
